<ion-header class="ion-no-border">

	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button (click)="close()">
				<fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>Currency</ion-title>
		<ion-buttons slot="end">
			<ion-button (click)="update()">
				<fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
			</ion-button>
		</ion-buttons>
	</ion-toolbar>

</ion-header>

<ion-content>

	<ion-list>
		<ion-radio-group *ngIf="supported_currencies && supported_currencies.length" [(ngModel)]="cart_currency_id">
			<ion-item *ngFor="let currency of supported_currencies" lines="full">
				<ion-radio class="primary" labelPlacement="start" value="{{currency.id}}">{{currency.title}}</ion-radio>
			</ion-item>
		</ion-radio-group>
	</ion-list>

</ion-content>